module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/main-visual-text-900f20068feba27653d0ec16ec5ffea6.png";